import { Fragment, useState } from "react";
import { Button, Container, Modal, Image, Row, Stack, Col } from "react-bootstrap";
import React from "react"
import "./ScreenShot.css"


export function ViewScreenshot(props) {
  const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

  return (

      <Fragment>
        <Row className="ImageIcon" >
          <Col>
            <Image src={props.src} height="85" width="85" onClick={() => handleShow(true) } ></Image>

          </Col>


        </Row>




      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Фото</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={props.src} height="150%" width="100%"></Image>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}
